import { isWithinInterval } from 'date-fns-new';
import { isEqalDate } from "../../utils/date";
export var isRangeParams = function isRangeParams(params) {
  return !!params.range;
};
export var isNotRangeParams = function isNotRangeParams(params) {
  return !params.range;
};
export var getDateView = function getDateView(date, value) {
  if (!value[0]) {
    return 'default';
  }
  if (!value[1] && isEqalDate(date, value[0])) {
    return 'selected';
  }
  if (isEqalDate(date, value[0])) {
    return 'start';
  }
  if (value[1] && isEqalDate(date, value[1])) {
    return 'end';
  }
  return value[1] && isWithinInterval(date, {
    start: value[0],
    end: value[1]
  }) ? 'in-range' : 'default';
};